import { Routes } from '@angular/router'

import {
    AdminLayoutComponent,
    Error403Component,
    Error4Component,
    Error5Component,
    GuardService,
    HandbookComponent,
    HandbookResolver,
    HandbookTypesResolver,
    LabelResolver,
    SettingsRouteGuard
} from '@surgetech-eu/core'
import { getRoleRoutes } from './app.roles'
import { ComponentTypeResolver } from './eyedes/handbook/component-type/component-type.resolver'
import { environment } from '../environments/environment'

const DamRedirectRoutes: Routes = [
    { path: 'product-images', redirectTo: 'dam/product-images', pathMatch: 'full' },
    { path: 'contents', redirectTo: 'dam/contents', pathMatch: 'full' },
    { path: '3d-management', redirectTo: 'dam/3d-management', pathMatch: 'full' },
    { path: 'master-image', redirectTo: 'dam/master-image', pathMatch: 'full' },
    { path: 'season-dates', redirectTo: 'dam/season-dates', pathMatch: 'full' },
    { path: 'users', redirectTo: 'dam/users', pathMatch: 'full' },
    { path: 'user-group', redirectTo: 'dam/user-group', pathMatch: 'full' },
    { path: 'view-ranking', redirectTo: 'dam/view-ranking', pathMatch: 'full' },
    { path: 'log-activities-product-images', redirectTo: 'dam/log-activities-product-images', pathMatch: 'full' },
    { path: 'log-activities-contents', redirectTo: 'dam/log-activities-contents', pathMatch: 'full' },
    { path: 'pop-images', redirectTo: 'dam/pop-images', pathMatch: 'full' },
    { path: 'api-user-management', redirectTo: 'dam/api-user-management', pathMatch: 'full' },
    { path: 'api-permission-management', redirectTo: 'dam/api-permission-management', pathMatch: 'full' }
]
export const AppRoutes: Routes = [
    // {
    //     path: 'catalog',
    //     component: AdminLayoutComponent,
    //     children: [{
    //         path: 'eyewear',
    //         component: EyewearComponent,
    //         resolve: {
    //             handbook: HandbookResolver,
    //             organizations: OrganizationResolver,
    //             labels: LabelResolver,
    //             libraries: ComponentResolverResolver
    //         },
    //         data: {
    //             labelContexts: [
    //                 'component.componentTable',
    //             ]
    //         },
    //     }],
    //     canActivate: [GuardService]
    // },
    // {
    //     path: 'catalog',
    //     component: AdminLayoutComponent,
    //     children: [{
    //         path: 'component',
    //         component: ComponentComponent,
    //         resolve: {
    //             handbook: HandbookResolver,
    //             organizations: OrganizationResolver,
    //             labels: LabelResolver,
    //             libraries: ComponentResolverResolver
    //         },
    //         data: {
    //             labelContexts: [
    //                 'component.componentTable',
    //             ]
    //         },
    //     }],
    //     canActivate: [GuardService]
    // },
    // {
    //   path: 'catalog',
    //   component: AdminLayoutComponent,
    //   children: [{
    //     path: 'cases',
    //     component: CaseSetComponent
    //   }],
    //   canActivate: [GuardService]
    // },
    {
        path: 'settings',
        component: AdminLayoutComponent,
        children: [
            {
                path: 'libraries',
                component: HandbookComponent,
                resolve: {
                    types: HandbookTypesResolver,
                    labels: LabelResolver,
                    unitOfMeasure: ComponentTypeResolver
                },
                data: {
                    labelContexts: [
                        'libraries.supplierTypeTable',
                        'libraries.supplierTable',
                        'libraries.mainPartTable',
                        'libraries.componentTypeTable',
                        'libraries.catalogObjectTypeTable',
                        'libraries.baseMaterialTable',
                        'libraries.baseMaterialCertificationTypeTable',
                        'libraries.materialFamilyTable'
                    ]
                },
                canActivate: [SettingsRouteGuard]
            }
        ],
        canActivate: [GuardService]
    },
    // tslint:disable-next-line:no-string-literal
    ...getRoleRoutes(window['__env']?.types || environment.types),
    ...DamRedirectRoutes,
    {
        path: 'error/404',
        component: Error4Component
    },
    {
        path: 'error/500',
        component: Error5Component
    },
    {
        path: 'error/403',
        component: Error403Component
    },
    {
        path: '**',
        redirectTo: 'error/404'
    }
]
